import axios from 'axios';

export const getTermsAndConditions = (platformCode) => {
  return axios.get(`api/terms/${platformCode}`);
};
